export const routes = [
  { id: 1, link: "#offer", name: "Co oferujemy", target: "none" },
  { id: 2, link: "#aboutUs", name: "Kim jesteśmy", target: "none" },
  { id: 3, link: "#realization", name: "Realizacje", target: "none" },
  { id: 4, link: "#contact", name: "Kontakt", target: "none" },
]
